module.exports = __webpack_public_path__ + "img/waistband partly elastic width.6d10c837.png";